import React, { useState } from "react";
import {IconButton, InputAdornment, TextField, Popover, Typography, Box, Chip} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { circularIconHoverSx } from "@/styles/iconHover";

interface RuleSaveProps {
    clipName: string;
    onClipNameChange: (clipName: string) => void;
}

const RuleSave: React.FC<RuleSaveProps> = ({clipName, onClipNameChange}) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleHelpClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleHelpClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <TextField
                label="Clip name"
                value={clipName}
                sx={{ maxWidth: 500, minWidth: 500 }}
                onChange={(e) => onClipNameChange(e.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleHelpClick} edge="end" sx={circularIconHoverSx()}>
                                <HelpOutlineIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleHelpClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
            >
                <Box sx={{ maxWidth: 320, p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
                        Help
                    </Typography>

                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                        Use these literals between brackets and Inbrief will automatically change them with real names!
                    </Typography>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
                        {['[home_team]', '[away_team]', '[event_name]', '[competition_name]', '[key_moment_type]', '[player]'].map((literal) => (
                            <Chip
                                key={literal}
                                label={literal}
                                size="small"
                                sx={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'medium',
                                    backgroundColor: 'primary'
                                }}
                            />
                        ))}
                    </Box>
                </Box>

            </Popover>
        </>
    );
}

export default RuleSave;

